import { isMockMode, post, simulateDelay } from "../api";

export const getIssuedSubs = (data) => {
	if (isMockMode()) {
		const testData = {
			totalAvailable: 0,
			fetchedCount: 0,
			paginationMetadata: {
				pageNo: 0,
				pageSize: 0,
				totalPages: 0,
			},
			skippedCount: 0,
			results: [
				{
					id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
					name: "Test Name",
					offering: {
						id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
						name: "string",
						websiteLinkUrl: "string",
					},
					type: 0,
					usedLicenceCount: 0,
					numberOfLicences: 0,
					expirationDateUtc: "2026-03-30T00:23:36.557Z",
					createdDateUtc: "2026-03-30T00:23:36.557Z",
					lastUpdatedDateUtc: "2026-03-30T00:23:36.557Z",
					createdBy: {
						id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
						email: "string",
						firstName: "string",
						lastName: "string",
					},
					isEnabled: true,
					subscriberOrg: {
						id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
						name: "string",
						isEnabledShareWithAnon: true,
						isEnabledShareOutsideOrg: true,
						customData: "string",
					},
					issuerOrg: {
						id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
						name: "string",
						isEnabledShareWithAnon: true,
						isEnabledShareOutsideOrg: true,
						customData: "string",
					},
					subscriptionManagers: [
						{
							id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
							email: "string",
							firstName: "string",
							lastName: "string",
						},
					],
					issuerNotes: "string",
					features: [
						{
							id: 0,
							code: "string",
							name: "string",
							description: "string",
						},
					],
				},
			],
			issuerOrgId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
		};

		return simulateDelay(50, () => testData);
	}

	return post(`Subscriptions/QueryIssuedSubs`, data);
};
